var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{attrs:{"id":"mainFooter"}},[_c('img',{attrs:{"src":require('@images/logo/unifael-ser.png'),"alt":"Centro Universitário UNIFAEL"}})])}
var staticRenderFns = []

export { render, staticRenderFns }